import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/modules/shared/shared.module';

import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeDescMarcheComponent } from './typeDescMarche/type-desc-marche.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { AnnulationComponent } from './annulation/annulation.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormDiversAnnulationComponent } from './FormDiversAnnulation/FormDiversAnnulation.component';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';
import { Step4Component } from './steps/step4/step4.component';
import { FormDiversCommonModule } from '../common/formdivers.module';

@NgModule({
  declarations: [
    TypeLieuComponent,
    TypeCPVClassComponent,
    TypeObjCPVComponent,
    TypeVoieComponent,
    TypeDescMarcheComponent,
    AvisInitialTypeComponent,
    AnnulationComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    FormDiversAnnulationComponent,
  ],
  exports: [FormDiversAnnulationComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule, FormDiversCommonModule],
})
export class FormDiversAnnulationModule {}
